export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export function authHeader () {
  // return authorization header with basic auth credentials
  const user = JSON.parse(localStorage.getItem('user'))

  if (user && user.token) {
      return { Authorization: 'Bearer ' + user.token, }
  } else {
      return {}
  }
}
